module.exports = __webpack_public_path__ + "img/TYS-1.2422192a.jpg";